import React from "react";
import { NavLink } from "react-router-dom";

const CapitalTaxValuationTab = () => {
  return (
    <div className="space-y-4 text-gray-800 py-10">
      <h2 className="text-xl font-semibold text-red-600">
        Capital Gains Tax Valuation
      </h2>

      <div className="space-y-2">
        <p>
          Accountant’s or Australian Tax Office (ATO) require independent
          capital gains valuation to work out the capital gains of an investment
          property which may formerly be owner occupied. Primus Agent
          Services have over ten (10) years experience in providing capital
          gains valuation to accountants and the Australian Taxation Office.
        </p>
      </div>

      <p className="text-blue-600 font-medium">
        Please{" "}
        <NavLink to="/contact-us" className="text-yellow">
          contact us{" "}
        </NavLink>{" "}
        for a guaranteed competitive quote.
      </p>
    </div>
  );
};

export default CapitalTaxValuationTab;
